import { SRPRS_DEV } from './env'
import { HotJarSettings } from './tracking/providers/hotjar'

const settingsCommon = {
  GoogleMapAPIKey: 'AIzaSyCrGYkSmrVWJ4EnZ5FGsSlUPhdyI4WSMXE',
  tracking: {
    facebook: '1446302895669921',
    googleAdWords: 'AW-965639417',
    activeCampaign: '999720408',
    bing: '5666045',
    snapchat: '96cf60c3-78cb-4222-9d0b-83db2b6e8cca',
  },
}

const settingsDev: Settings = {
  ...settingsCommon,
  tracking: {
    ...settingsCommon.tracking,
    googleAnalyticsId: 'UA-42198950-4',
    googleOptimizeId: '',
    googleTagManagerId: '',
    hotJar: {
      hjid: 0,
      hjsv: 0,
    },
    memberGetMember: 'https://tracking.mgmco-acceptance.nl',
  },
  sentryDsn: '',
}

const settingsNonDev: Settings = {
  ...settingsCommon,
  tracking: {
    ...settingsCommon.tracking,
    googleAnalyticsId: 'UA-42198950-1',
    googleOptimizeId: 'GTM-53WCFPQ',
    googleTagManagerId: 'GTM-PFX6V2C',
    hotJar: {
      hjid: 82011,
      hjsv: 6,
    },
    memberGetMember: 'https://tracking.membergetmember.co',
  },
  sentryDsn: 'https://5586a82065eb411ea7151fff066e6ebc@sentry.io/1187979',
}

export const settings: Settings = SRPRS_DEV ? settingsDev : settingsNonDev

export default interface Settings {
  GoogleMapAPIKey: string
  tracking: {
    googleAnalyticsId: string
    googleOptimizeId: string
    googleTagManagerId: string
    hotJar: HotJarSettings
    memberGetMember: string
    facebook: string
    googleAdWords: string
    activeCampaign: string
    bing: string
    snapchat: string
  }
  sentryDsn: string
}
